(() => {
  const panel = document.getElementById('js-scroll-panel');
  const conceptElement = document.getElementById('js-scroll-concept');
  const featuredProductsElement = document.getElementById(
    'js-scroll-featured-products'
  );
  const characters = document.getElementsByClassName('js-scroll-character');
  const colorBlack = '#272828';
  const colorWhite = '#FFFFFF';

  window.addEventListener('scroll', function () {
    // 画面の高さ
    const windowHeight = window.innerHeight;
    // スクロール位置の高さ
    const scroll = window.pageYOffset;
    // HTMLトップからCONCEPT要素、Featured Products要素までの高さ
    const conceptPosition = conceptElement.getBoundingClientRect().top + scroll;
    const featuredProductsPosition =
      featuredProductsElement.getBoundingClientRect().top + scroll;

    // CONCEPTに差し掛かったら背景色を黒、文字色を白
    if (scroll > conceptPosition - windowHeight) {
      panel.style.backgroundColor = colorBlack;
      for (const character of characters) {
        character.style.color = colorWhite;
      }
    }

    // Featured Productsを境に背景色、文字色を切り替え
    if (scroll > featuredProductsPosition - windowHeight) {
      panel.style.backgroundColor = colorWhite;
      for (const character of characters) {
        character.style.color = colorBlack;
      }
    }
  });
})();
